import type { SplitPlan } from "@CommonTypes/algo/generated-pogger";
import { Color, Text } from "src/elements";
import { useTranslation } from "src/i18n";
import { describeSplitPlan, wordSplitPlanSentence } from "src/utils/describeSplitPlan";

const NO_NAMES: ReadonlyMap<string, string> = new Map();

interface Props {
  plan: SplitPlan | undefined;
  cdtNames?: ReadonlyMap<string, string>;
  /** Flow Update made this pog for a store with a break, and it does not keep brands within it. */
  brandsMayCrossAisleBreak?: boolean;
  variant?: "body2" | "small2";
}

export const SplitPlanSummary = ({
  plan,
  cdtNames = NO_NAMES,
  brandsMayCrossAisleBreak = false,
  variant = "small2",
}: Props) => {
  const { t } = useTranslation("common");
  const lines = describeSplitPlan(plan, cdtNames).map((sentence) =>
    wordSplitPlanSentence(t, sentence),
  );
  if (brandsMayCrossAisleBreak) lines.push(t("aisleBreaks.result.editedAfterGeneration"));
  if (lines.length === 0) return null;

  return (
    <Text
      variant={variant}
      color={Color.textSecondary}
      whiteSpace="wrap"
      testId="split-plan-summary"
    >
      {lines.join(" ")}
    </Text>
  );
};
